import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import SITE from '../../api';
import useSEO from '../../useSEO';
import { IMG, useSite } from '../../components/StoreLayout';
import { STORE_BASE } from '../../routeBase';

export default function StaffTrainingResources() {
  const { content: c } = useSite();
  useSEO({
    title: c['tools.staff-training-resources.meta_title'] || 'Free Staff Training Handbooks for Opticians',
    description: c['tools.staff-training-resources.meta_description'] || 'Free downloadable PDF cheat-sheets to train new optical staff — frame adjustments, lens materials, and taking accurate PD measurements.',
    keywords: c['tools.staff-training-resources.meta_keywords'] || 'optician staff training, optical shop onboarding, frame adjustment guide, PD measurement guide, lens materials cheat sheet',
    canonical: `${window.location.origin}/store/tools/staff-training-resources`,
  });

  const [resources, setResources] = useState(null);

  useEffect(() => {
    SITE.get('/staff-training-resources').then(r => setResources(r.data.resources || [])).catch(() => setResources([]));
  }, []);

  const card = { background: '#fff', border: '1px solid #eee', borderRadius: 14, padding: '22px 22px 20px', display: 'flex', flexDirection: 'column' };

  return (
    <div style={{ background: 'var(--sf-body-bg)' }}>
      {/* HERO */}
      <section style={{ maxWidth: 900, margin: '0 auto', padding: '48px 24px 16px', textAlign: 'center' }}>
        <Link to={`${STORE_BASE}/tools`} style={{ fontSize: 12.5, color: 'var(--sf-hover)', fontWeight: 600, textDecoration: 'none' }}>
          <i className="ti ti-arrow-left" style={{ fontSize: 13, verticalAlign: -1 }} /> All free tools
        </Link>
        <h1 style={{ fontSize: 'clamp(24px,3.6vw,34px)', fontWeight: 800, color: 'var(--sf-primary)', margin: '14px 0 12px' }}>
          Train New Optical Staff
        </h1>
        <p style={{ fontSize: 14.5, color: 'var(--sf-muted)', maxWidth: 640, margin: '0 auto', lineHeight: 1.7 }}>
          Independent shops lose training time to staff turnover. Download these printable cheat-sheets covering the basics of frame adjustments, lens materials, and taking accurate PD measurements — hand them to a new hire on day one. No login, no cost.
        </p>
      </section>

      <section style={{ maxWidth: 900, margin: '24px auto 0', padding: '0 24px 64px' }}>
        {resources === null && <div style={{ textAlign: 'center', color: 'var(--sf-muted)', padding: '40px 0' }}>Loading resources…</div>}
        {resources && resources.length === 0 && <div style={{ textAlign: 'center', color: 'var(--sf-muted)', padding: '40px 0' }}>No resources available right now — check back soon.</div>}

        {resources && resources.length > 0 && (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 22 }}>
            {resources.map(r => (
              <div key={r.id} style={card}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
                  <div style={{ width: 46, height: 46, borderRadius: 10, background: '#fee2e2', color: '#dc2626', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                    <i className="ti ti-file-type-pdf" style={{ fontSize: 22 }} />
                  </div>
                  <div>
                    {r.category && (
                      <span style={{ fontSize: 10.5, fontWeight: 700, letterSpacing: 0.4, textTransform: 'uppercase', color: 'var(--sf-hover)', display: 'block', marginBottom: 3 }}>
                        {r.category}
                      </span>
                    )}
                    <h3 style={{ fontSize: 15, fontWeight: 700, color: 'var(--sf-primary)', margin: 0 }}>{r.title}</h3>
                  </div>
                </div>
                {r.description && <p style={{ fontSize: 12.5, color: 'var(--sf-muted)', lineHeight: 1.6, margin: '0 0 16px', flex: 1 }}>{r.description}</p>}
                <a href={IMG(r.file_path)} download
                  onClick={() => SITE.post(`/staff-training-resources/${r.id}/download`).catch(() => {})}
                  style={{
                    display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 6, background: 'var(--sf-primary)', color: '#fff',
                    borderRadius: 8, padding: '10px 16px', fontSize: 12.5, fontWeight: 700, textDecoration: 'none', marginTop: 'auto',
                  }}>
                  <i className="ti ti-download" style={{ fontSize: 14 }} /> Download PDF
                </a>
              </div>
            ))}
          </div>
        )}
      </section>

      {/* CTA BANNER */}
      <section style={{ background: 'var(--sf-primary)', color: '#fff' }}>
        <div style={{ maxWidth: 1100, margin: '0 auto', padding: '32px 24px', display: 'flex', flexWrap: 'wrap', gap: 20, alignItems: 'center', justifyContent: 'space-between' }}>
          <div>
            <h3 style={{ fontSize: 17, fontWeight: 800, margin: '0 0 6px' }}>Give your new hire something worth selling</h3>
            <p style={{ fontSize: 12.5, color: 'rgba(255,255,255,0.75)', margin: 0, maxWidth: 460 }}>
              Browse our latest wholesale frame collections — acetate, TR90 and metal, shipped worldwide.
            </p>
          </div>
          <Link to={`${STORE_BASE}/shop`} style={{
            background: '#fff', color: 'var(--sf-primary)', padding: '11px 22px', borderRadius: 8,
            fontWeight: 700, fontSize: 13, textDecoration: 'none', flexShrink: 0,
          }}>
            Browse Wholesale Catalog
          </Link>
        </div>
      </section>
    </div>
  );
}
